import bigDecimal from "js-big-decimal";

// condition classes
export const VOTING_CONDITION: string = "condition.voting";
export const SYMBOL_CONDITION: string = "condition.symbol";
export const AMOUNT_CONDITION: string = "condition.amount";
export const AMOUNT_PERCENT_CONDITION: string = "condition.amount_percent";
export const IMMUTABLE_CONDITION: string = "condition.immutable";
export const NO_ACTIVE_CONDITION: string = "condition.noactive";
export const VOTING_MANDATORY_CONDITION: string = "condition.voting-mandatory";
export const CREATE_BY_SAFE_CONDITION: string = "condition.create_by_safe";
export const ALLOW_FUNCTIONS_ON_PROFILE_CONDITION: string = "condition.allow_functions_onprofile";
export const ALLOW_UPDATE_USER_ADDRESS_CONDITION: string = "condition.allow_updateUserAddress";

export const conditionsToParse = [
  IMMUTABLE_CONDITION,
  SYMBOL_CONDITION,
  AMOUNT_CONDITION,
  VOTING_CONDITION,
  NO_ACTIVE_CONDITION,
  AMOUNT_PERCENT_CONDITION,
  VOTING_MANDATORY_CONDITION,
  ALLOW_UPDATE_USER_ADDRESS_CONDITION,
];

// object classes
export const POLICY_CLS: string = "policy";
export const GROUP_CLS: string = "group";
export const USER_CLS: string = "user";
export const TRANSACTION_CLS: string = "transaction";
export const PENDING_TRANSACTION_CLS: string = "pending_transaction";
export const VOTING_CLS: string = "voting";
export const VOTE_CLS: string = "vote";
export const CREATE_SAFE: string = "create_safe";
export const PROFILE_CLS: string = "profile";
export const DEPOSIT_CLS: string = "deposit";

export const PRIMARY_GROUP: string = "Primary";
export const SAFE_PROFILE_ID: string = "safe_profile";

export const NO_HELPERS: string = "No helpers";
export const ONE_HELPER: string = "1 helper";
export const ONE_PERSON_IN_THRESHOLD: string = "1 person in threshold";
export const ABOVE_80_PERCENT_HELPERS: string = "80% > helpers";
export const BELOW_20_PERCENT_HELPERS: string = "20% < helpers";
export const INACTIVE_HELPERS: string = "Inactive helpers";
export const RISKY_INACTIVE_HELPERS: string = "Too many inactive helpers";
export const ONLY_EMAIL: string = "Only email";
export const SECURED: string = "Secured";

export const supportedAppObjects = [GROUP_CLS, TRANSACTION_CLS, POLICY_CLS, VOTE_CLS, USER_CLS];

export const EMAIL_HELPER_ADDRESS = "omnistar1u52scz4upns90680yhsk7nyqqmea67ahqn3wuw";

export const OMNI_URL: string = "https://www.omnni.io/";
export const CHANGENOW_URL: string = "https://changenow.io/";
export const CHANGELLY_URL: string = "https://changelly.com/";

export const WIKEY_URL: string = "https://www.wikey.io/";
export const WIKEY_STORE_PATH: string = "category/tokens?key=";
export const WIKEY_STORE_URL: string = "https://store.wikey.io?address=";
export const WIKEY_CHAIN_ID: string = "omnistar:self";
export const COSMOS_CHAIN_ID: string = "cosmos:omnistar:self";

export const BIG_DECIMAL_ZERO = new bigDecimal(0);
export const BIG_DECIMAL_BILLION = new bigDecimal("1000000000");
export const MIN_NUMBER_TO_DISPLAY = new bigDecimal("0.001");
export const MIN_TOKENS_TO_CREATE_PROFILE = new bigDecimal("2");

// Constants
export const LOADING_MESSAGES = {
  PROCESSING: "Processing request...",
  APPROVAL: "Please approve the transaction in your mobile wallet app...",
  LOADING_HELPERS: "Loading helpers...",
  REFRESHING_HELPERS: "Refreshing helpers...",
  FETCHING_UPDATED_HELPERS: "Fetching updated helper addresses...",
  LOADING_SNAPSHOT: "Loading snapshot...",
} as const;
